<div class="add-art-container tab-container">
  <div *ngIf="isLoaderVisible">
    <app-loader></app-loader>
  </div>
  <div *ngIf="isDataReady">
    <div *ngIf="loggedInUser.role_id === 3; else buyerOrArtist" style="text-align: justify;">
      {{'artistAccountNotValidatedYet' | translate}}
    </div>
    <ng-template #buyerOrArtist>
      <p *ngIf="!canAddArt" class="center">
        {{'youReachedMaximumNrOfAddedArt' | translate}}
      </p>
      <div *ngIf="canAddArt">
        <div *ngFor="let artObject of artObjects" class="art-object">

          <form>
            <div *ngIf="!isEditArtVisible; else editArtImage" class="flex">
              <mat-icon (click)="openDialogDeleteImage(artObject)" *ngIf="artObject.image.name !== ''" class="clickable">close</mat-icon>
              <button mat-raised-button class="simple-button" (click)="fileInput.click()" *ngIf="artObject.image.name === ''">
                <span style="display: flex; align-items: center"><mat-icon> insert_photo</mat-icon> {{'uploadImage' | translate}}</span>
                <input #fileInput type="file" (change)="fileEvent(artObject, $event)" style="display:none;" accept="image/png, image/jpg, image/jpeg" />
              </button>
              <label *ngIf="artObject.image.name !== ''">{{artObject.image.name}}</label>
            </div>

            <p *ngIf="imageSizeError" class="error-message">{{'imageTooBig' | translate}}. <a target="_blank" href="https://www.iloveimg.com/resize-image">{{'resizeImgHere' | translate}}</a></p>

            <ng-template #editArtImage>
              <div class="edit-art-image">
                <img [src]="backendAddress + imgEditArtPath" >
              </div>
            </ng-template>

            <mat-form-field class="half-width">
              <mat-label>{{'addArtTitle' | translate}}</mat-label>
              <input matInput [formControl]="titleFormControl">
              <mat-error *ngIf="titleFormControl.hasError('required')">
                {{'orderFormFieldIs' | translate}} <strong>{{'required' | translate}}</strong>
              </mat-error>
            </mat-form-field>

            <mat-form-field class="half-width">
              <mat-label>{{'addArtDescription' | translate}}</mat-label>
              <input matInput [formControl]="descriptionFormControl">
              <mat-error *ngIf="descriptionFormControl.hasError('required')">
                {{'orderFormFieldIs' | translate}} <strong>{{'required' | translate}}</strong>
              </mat-error>
            </mat-form-field>

            <mat-form-field class="half-width">
              <mat-label>{{'addArtCategory' | translate}}</mat-label>
              <mat-select class="full-width" [formControl]="categoryFormControl">
                <mat-option *ngFor="let category of categories" [value]="category.id">{{category.name | translate}} </mat-option>
              </mat-select>
              <mat-error *ngIf="categoryFormControl.hasError('required')">
                {{'orderFormFieldIs' | translate}} <strong>{{'required' | translate}}</strong>
              </mat-error>
            </mat-form-field>

            <mat-form-field class="half-width">
              <mat-label>{{'addArtAvailability' | translate}}</mat-label>
              <mat-select class="full-width" [formControl]="availabilityFormControl">
                <mat-option *ngFor="let availability of availabilities" [value]="availability.id">{{availability.name | translate}}</mat-option>
              </mat-select>
              <mat-error *ngIf="availabilityFormControl.hasError('required')">
                {{'orderFormFieldIs' | translate}} <strong>{{'required' | translate}}</strong>
              </mat-error>
            </mat-form-field>

            <mat-form-field class="half-width">
              <mat-label>{{'addArtDimension' | translate}}</mat-label>
              <input matInput [formControl]="dimensionFormControl">
              <mat-error *ngIf="dimensionFormControl.hasError('required')">
                {{'orderFormFieldIs' | translate}} <strong>{{'required' | translate}}</strong>
              </mat-error>
            </mat-form-field>

            <mat-form-field class="half-width">
              <mat-label>{{'addArtTechnique' | translate}}</mat-label>
              <input matInput [formControl]="techniqueFormControl">
              <mat-error *ngIf="techniqueFormControl.hasError('required')">
                {{'orderFormFieldIs' | translate}} <strong>{{'required' | translate}}</strong>
              </mat-error>
            </mat-form-field>

            <mat-form-field class="half-width">
              <mat-label>{{'addArtYear' | translate}}</mat-label>
              <input matInput [formControl]="yearFormControl">
              <mat-error *ngIf="yearFormControl.hasError('required')">
                {{'orderFormFieldIs' | translate}} <strong>{{'pattern' | translate}}</strong>
              </mat-error>
              <mat-error *ngIf="yearFormControl.hasError('pattern')">
                {{'orderFormControlYearPattern' | translate}} <strong>{{'required' | translate}}</strong>
              </mat-error>
            </mat-form-field>

            <mat-form-field class="half-width">
              <mat-label>{{'addArtPrice' |translate}}</mat-label>
              <input matInput [formControl]="priceFormControl" placeholder="0">
              <mat-error *ngIf="priceFormControl.hasError('pattern')">
                {{'priceError' | translate}}
              </mat-error>
              <mat-error *ngIf="priceFormControl.hasError('required')">
                {{'orderFormFieldIs' | translate}} <strong>{{'pattern' | translate}}</strong>
              </mat-error>
              <span matPrefix style="margin-right: 10px">Lei</span>
            </mat-form-field>

            <p class="error-message">{{errorMessage}}</p>

            <button mat-raised-button class="simple-button margin" (click)="onSubmitform2(artObject.image.name)" [disabled]="addArtForm.invalid">{{'saveArt' | translate}}</button>
            <button mat-raised-button color="warn" *ngIf="isEditArtVisible" style="margin-top: 10px" (click)="cancelEdit()">{{'cancelArt' | translate}}</button>

          </form>

        </div>
      </div>
    </ng-template>
  </div>
</div>
